module.exports = __webpack_public_path__ + "static/images/timing-pop.65b9dec.png";